module.exports = __webpack_public_path__ + "img/7stars.a0e3d645.jpg";